import React, { useState } from "react";
import styles from "./index.module.scss";
import InputSearchIcon from "../searchInput";
import MobileSliderMenu from "../mobile-slider";
import MobileSliderMenuBody from "../mobile-slider-menu-body";
import { useLocation } from "react-router-dom";
import { useDebounce } from "primereact/hooks";

export default function MobilePropertiesHeader({
  searchValue,
  debouncedSearchValue,
  setSearchValue,
  searchParams,
  setSearchParams,
  type
}: {
  searchValue: string;
  debouncedSearchValue: string;
  searchParams: any;
  setSearchParams: (searchParams: any) => void;
  setSearchValue: (searchValue: string) => void;
  type: string;
}) {
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const [filterReset, setFilterReset] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const location = useLocation();
  const isPreOn =
    type === "agent" &&
    (searchParams.get("showPre") === null
      ? true
      : searchParams.get("showPre") === "true");
  const [
    preSearchValue,
    debouncedPreSearchValue,
    setPreSearchValue
  ] = useDebounce(
    type === "agent" ? searchParams.get("searchTxtPre") || "" : "",
    400
  );

  const handleReset = () => {
    setFilterReset(true);
    setTimeout(() => setFilterReset(false), 1000);
  };

  React.useEffect(() => {
    const updateFilterCount = () => {
      const currentUrl = new URL(window.location.href);
      const params: any = new URLSearchParams(currentUrl.search);
      const filterCountExcludingSearch = [...params].filter(
        ([key]) =>
          key !== "searchText" &&
          key !== "sort" &&
          key !== "layout" &&
          key !== "page" &&
          key !== "limit" &&
          key !== "lat" &&
          key !== "lng" &&
          key !== "zoom" &&
          key !== "order"
      ).length;

      setFilterCount(filterCountExcludingSearch);
    };

    const updatedParams = new URLSearchParams(location.search);
    if (!isPreOn) {
      if (debouncedSearchValue.length > 0) {
        updatedParams.set("searchText", debouncedSearchValue);
      } else {
        updatedParams.delete("searchText");
      }
      setSearchParams(updatedParams);
    }

    updateFilterCount();

    window.addEventListener("popstate", updateFilterCount);

    return () => {
      window.removeEventListener("popstate", updateFilterCount);
    };
  }, [location.search, debouncedSearchValue, isPreOn, setSearchParams]);

  React.useEffect(() => {
    if (type !== "agent") return;
    const updatedParams = new URLSearchParams(searchParams);
    if (debouncedPreSearchValue) {
      updatedParams.set("searchTxtPre", debouncedPreSearchValue);
    } else {
      updatedParams.delete("searchTxtPre");
    }
    setSearchParams(updatedParams);
  }, [debouncedPreSearchValue, searchParams, setSearchParams, type]);

  React.useEffect(() => {
    if (type !== "agent") return;
    const currentPreSearch = searchParams.get("searchTxtPre") || "";
    setPreSearchValue((prev: string) =>
      prev === currentPreSearch ? prev : currentPreSearch
    );
  }, [searchParams, setPreSearchValue, type]);

  const handleSearchChange = (e: any) => {
    const value = e.target.value;
    if (isPreOn && type === "agent") {
      setPreSearchValue(value);
    } else {
      setSearchValue(value);
    }
  };

  return (
    <div className={styles.mobilePropertiesHeader}>
      <MobileSliderMenu
        title="Filtering"
        visibleDrawer={visibleDrawer}
        setVisibleDrawer={setVisibleDrawer}
        handleReset={handleReset}
      >
        <MobileSliderMenuBody
          reset={filterReset}
          setVisibleDrawer={setVisibleDrawer}
        />
      </MobileSliderMenu>
      <div className={styles.searchBoxWrap}>
        <InputSearchIcon
          placeholder={
            isPreOn && type === "agent"
              ? "Search on Account, Entities and address"
              : "Address, City or ZIP"
          }
          className={styles.searchInputBox}
          searchIcon={true}
          value={
            isPreOn && type === "agent" ? preSearchValue : searchValue
          }
          resetSearch={() => {
            if (isPreOn && type === "agent") {
              setPreSearchValue("");
            } else {
              setSearchValue("");
            }
          }}
          onChange={handleSearchChange}
        />
      </div>
      {type === "agent" && (
        <div className={styles.filterImgWrap}>
          <img
            src="/images/filter1.svg"
            alt="filter"
            onClick={() => setVisibleDrawer(true)}
          />
          {filterCount > 0 && (
            <span className={styles.count}>{+filterCount}</span>
          )}
        </div>
      )}
    </div>
  );
}
